import { FANTASY_CONSTANTS } from '@pff-consumer/schema'

const { NUM_OF_GAMES_PER_TEAM } = FANTASY_CONSTANTS

const roundNumber = (value: number) => value.toFixed(1)

export const transformProjectionToPPG = (projectedPoints: number) => {
  return roundNumber(projectedPoints / NUM_OF_GAMES_PER_TEAM)
}
